import PhoneNumbers from "../PhoneNumbers";
import "./index.css";
import React from "react";

const Hero = () => {
    return (
        <section className="hero">
            <PhoneNumbers />
        </section>
    )
}
export default Hero;